"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateShiftIncluded = void 0;
const agencyOpeningTimes_utils_1 = require("./agencyOpeningTimes.utils");
function isDateShiftIncluded(shifts, timeZone, currentDate) {
    const utcDate = (0, agencyOpeningTimes_utils_1.convertToUTC)(currentDate);
    return shifts
        .map(shift => (0, agencyOpeningTimes_utils_1.shiftToDateTuple)(shift, timeZone, currentDate))
        .some(([...shiftDateTuple]) => (0, agencyOpeningTimes_utils_1.isDateInShiftTuple)(utcDate, shiftDateTuple));
}
exports.isDateShiftIncluded = isDateShiftIncluded;
//# sourceMappingURL=isDateShiftIncluded.js.map